import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2eb5bd38"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "input-box ml-4",
  style: {"position":"relative"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dollar-sign" }, "$", -1))
const _hoisted_3 = {
  key: 1,
  class: "input-box ml-4",
  style: {"position":"relative"}
}
const _hoisted_4 = {
  key: 2,
  class: "input-box",
  style: {"position":"relative"}
}

export function render(_ctx, _cache) {
  const _component_Popover = _resolveComponent("Popover")
  const _component_CurrencyInput = _resolveComponent("CurrencyInput")

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["input-text-number-currency", _ctx.validForm() ? 'answered' : ''])
  }, [
    _createElementVNode("h4", null, [
      _createTextVNode(_toDisplayString(_ctx.newWording) + " ", 1),
      _createVNode(_component_Popover, { popover: _ctx.obj }, null, 8, ["popover"])
    ]),
    (_ctx.questionTypeId == 5)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_CurrencyInput, {
            class: "amount pr-3",
            modelValue: _ctx.question.responses[0].answerCurrency,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.question.responses[0].answerCurrency) = $event)),
            onKeyup: _cache[1] || (_cache[1] = $event => (_ctx.validForm())),
            options: { currency: 'USD', currencyDisplay: 'hidden', precision: 2, valueRange:{ min: -999999999999, max: 999999999999} }
          }, null, 8, ["modelValue"]),
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    (_ctx.questionTypeId == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_CurrencyInput, {
            class: "amount pr-3",
            modelValue: _ctx.question.responses[0].answerNumber,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.question.responses[0].answerNumber) = $event)),
            onKeyup: _cache[3] || (_cache[3] = $event => (_ctx.validForm())),
            options: { currency: 'USD', currencyDisplay: 'hidden', valueRange:{ min: -999999999, max: 999999999} }
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.questionTypeId == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "pr-3",
            type: "text",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.question.responses[0].answerTxt) = $event)),
            onKeyup: _cache[5] || (_cache[5] = $event => (_ctx.validForm()))
          }, null, 544), [
            [_vModelText, _ctx.question.responses[0].answerTxt]
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}